import React from 'react';
import type { AdminPermission, AdminRole } from '@hisob/types';
import { useAuth } from '../../context/AuthContext.js';

interface PermissionGuardProps {
  permission?: AdminPermission;
  roles?: AdminRole[];
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

export function PermissionGuard({
  permission,
  roles,
  fallback = null,
  children,
}: PermissionGuardProps) {
  const { admin, hasPermission } = useAuth();

  if (!admin) return <>{fallback}</>;

  if (roles && !roles.includes(admin.role)) {
    return <>{fallback}</>;
  }

  if (permission && !hasPermission(permission)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
